import ButtonBase from 'v2/components/UI/ButtonBase';
import { IOption } from '../../types';
import Box from 'v2/components/UI/Box';
import Icon from 'v2/components/Icon';
import { IIconName } from 'v2/resources/types/icon';
import { ReactComponent as FishIcon } from '../../../../assets/icons/peixe-icon.svg';
import { ReactComponent as ShrimpIcon } from '../../../../assets/icons/camarão-icon.svg';
import useOptionsList from './hooks/useOptionsList';

interface Props {
  items: IOption[];
  selected?: string;
}
const OptionsList: React.FC<Props> = ({ items, selected }) => {
  const { selectedRef } = useOptionsList(selected);
  const renderIconLeft = (iconName: IIconName | 'Camarão' | 'Peixe') => {
    const COLOR = iconName === 'LogoutOutlined' ? '#F00' : '#005F47';

    if (!iconName) {
      return (
        <Icon iconName={'TrackChangesOutlined'} size={24} htmlColor={COLOR} />
      );
    }

    if (iconName === 'Peixe') {
      return <FishIcon width={22} height={22} color={COLOR} fill={COLOR} />;
    }

    if (iconName === 'Camarão') {
      return <ShrimpIcon width={22} height={22} color={COLOR} fill={COLOR} />;
    }
    return <Icon iconName={iconName} size={24} htmlColor={COLOR} />;
  };

  return (
    <Box
      flexDirection="column"
      gap={14}
      padding={20}
      borderRadius={16}
      maxHeight={300}
      overflowY="auto"
    >
      {items.map(({ id, title, iconName, onClick }) => {
        const SELECTED = selected === title;
        const COLOR = title === 'Sair' ? '#F00' : '#1b1b1b';
        const COLOR_SELECTED = SELECTED ? '#005F47' : COLOR;
        const BACKGROUND_SELECTED = SELECTED ? '#b7ffbd80' : 'transparent';
        const FONT_WEIGHT_SELECTED = SELECTED ? 700 : 500;
        const PADDING_SELECTED = SELECTED ? 15 : 5;

        return (
          <Box key={id} ref={SELECTED ? selectedRef : null}>
            <ButtonBase
              alignItems="center"
              gap={5}
              borderRadius={8}
              fontSize={17}
              onClick={onClick}
              color={COLOR_SELECTED}
              fontWeight={FONT_WEIGHT_SELECTED}
              padding={PADDING_SELECTED}
              background={BACKGROUND_SELECTED}
            >
              {renderIconLeft(iconName)}
              {title}
            </ButtonBase>
          </Box>
        );
      })}
    </Box>
  );
};

export default OptionsList;
